<template>
  <email-filter
    :options="emailAutomationOptions"
    :icon="IconIncomingArrow"
    :title="$t('EMAIL_INTEGRATION.AUTOMATION.SELECT')"
    placeholder-key="EMAIL_INTEGRATION.AUTOMATION.SELECT"
    :render-component="EmailAutomationOption"
    query-key="email_is_automated"
    :toggle-from-parent
  />
</template>
<script setup lang="ts">
import { emailAutomationOptions } from "@/helpers/constants/emails";

import EmailAutomationOption from "@/components/communicationLogs/filters/emailFilters/EmailAutomationOption.vue";
import EmailFilter from "@/components/communicationLogs/filters/emailFilters/EmailFilter.vue";
import IconIncomingArrow from "@/components/icons/IconIncomingArrow.vue";

const { toggleFromParent = false } = defineProps<{
  toggleFromParent?: boolean;
}>();
</script>
